import PageBreadcrumb from "@/components/common/PageBreadCrumb";
import Tabs from "@/components/Usados/Tabs";
import ActividadesTab from "../tabs/ActividadesTab";
import EmpleadosTab from "../tabs/UsuariosTab";
import EquiposTab from "../tabs/EquiposTab";
import ProyectosTab from "../tabs/ProyectosTab";
import RolesTab from "../tabs/RolesTab";
import Historial from "../tabs/historial"
import MovimientosTab from "../tabs/movimientosTab";

export default function ListarProyectos() {
  const tabs = [
    {
      value: "proyectos",
      label: "Proyectos",
      content: <ProyectosTab />,
    },
    {
      value: "actividades",
      label: "Actividades",
      content: <ActividadesTab />,
    },
    {
      value: "equipos",
      label: "Equipos",
      content: <EquiposTab />,
    },
    {
      value: "roles",
      label: "Roles (proyecto)  ",
      content: <RolesTab />,
    },
    {
      value: "empleados",
      label: "Usuarios y tareas",
      content: <EmpleadosTab />,
    },
    {
      value: "movimientos",
      label: "Movimientos",
      content: <MovimientosTab />,
    },
    {
      value: "historial",
      label: "Cambios actividad",
      content: <Historial />,
    },
  ];

  return (
    <div>
      <PageBreadcrumb pageTitle="Gestion de Proyectos" />
      <div className="min-h-screen rounded-2xl border border-gray-200 bg-white px-5 py-7 dark:border-gray-800 dark:bg-white/[0.03] xl:px-10 xl:py-12">
        <h3 className="mb-4 font-semibold text-gray-800 text-center text-theme-xl dark:text-white/90 sm:text-2xl">
          Administracion de Proyectos
        </h3>

        <Tabs tabs={tabs} />
      </div>
    </div>
  );
}
